import styles from '@styles/scss/common/_contentDescription.module.scss';
import { replaceUrls } from 'lib/helper/localUrls';

export default function AboveTheFoldContent({
    content,
    currentLang
}: {
    content: string;
    currentLang: string;
}): JSX.Element {
    const regex = /href=['"]([^'"]*)['"]/g;

    if (currentLang !== 'en') {
        content = content.replace(regex, (match, url) => replaceUrls(match, url, currentLang));
    }

    return (
        <div
            className={`${styles.container} ${styles.aboveTheFold} ${styles.categoryPage}`}
            dangerouslySetInnerHTML={{
                __html: content
            }}></div>
    );
}
